<template>
  <div id="app">
    <notifications />
    <Base />
  </div>
</template>

<script>
import Base from "@/layout/Base";
export default {
  name: "App",
  components: {
    Base,
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");

#app {
  font-family: Roboto;
}
</style>
